import { render, staticRenderFns } from "./available-examinations-component.vue?vue&type=template&id=119f8274&scoped=true"
import script from "./available-examinations-component.vue?vue&type=script&setup=true&lang=ts"
export * from "./available-examinations-component.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./available-examinations-component.vue?vue&type=style&index=0&id=119f8274&prod&scoped=true&lang=css"
import style1 from "./available-examinations-component.vue?vue&type=style&index=1&id=119f8274&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119f8274",
  null
  
)

export default component.exports